import '@babel/polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import './assets/css/element-variables.scss'
import './assets/css/element-theme.css'

import App from './App.vue'
import store from './store'
import router from './router'
import './permission'
import './style/index.scss'
import i18n from './lang'
import * as filters from './filters'
import './plugins/vuetify'
// https://github.com/youzan/vant/issues/3241
import { Dialog, Uploader, Button, TreeSelect, Field } from 'vant'
import VueKonva from './lib/konva'
// import './share'
import { Tab, Tabs } from 'vant'
import { Icon } from 'vant'

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(VueKonva)
Vue.use(Dialog)
Vue.use(Uploader)
Vue.use(ElementUI)
Vue.use(Button)
Vue.use(TreeSelect)
Vue.use(Field)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
